import * as React from 'react';
import PropTypes from 'prop-types';

const SvgSportsSnowboardNormalLarge = React.forwardRef(
  ({ color, size, title, titleId, ...props }, ref) => (
    <svg
      fill={color}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 48 48"
      ref={ref}
      width={size}
      height={size}
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <path
        d="M36.265.933a7.922 7.922 0 00-11.01 3.893l-3.837 9.022a90.34 90.34 0 01-7.331 13.783L8.81 35.763a7.92 7.92 0 1013.934 7.411l3.815-8.974a90.281 90.281 0 017.328-13.784l5.305-8.179A7.922 7.922 0 0036.265.933zm1.25 10.217l-5.306 8.179a92.216 92.216 0 00-7.491 14.089L20.9 42.391a5.922 5.922 0 11-10.415-5.54l5.277-8.132a92.373 92.373 0 007.494-14.088L27.1 5.609a5.923 5.923 0 1110.415 5.541z"
        fill=""
      />
      <path
        d="M22.545 27.781l-.866-.461a3.002 3.002 0 00-4.545 2.32 3 3 0 001.732 2.969l.866.461a3 3 0 102.813-5.289zm-.527 3.112a1 1 0 01-1.346.412l-.867-.461a1 1 0 01.176-1.831 1 1 0 01.759.073l.867.461a1 1 0 01.41 1.346zm5.988-15.887h-.98a3 3 0 000 5.991h.98a3 3 0 100-5.991zm0 3.991h-.98a1 1 0 010-1.991h.98a1 1 0 110 1.991z"
        fill=""
      />
    </svg>
  )
);
SvgSportsSnowboardNormalLarge.defaultProps = {
  color: 'currentColor',
  size: 48,
  title: undefined,
  titleId: undefined
};
SvgSportsSnowboardNormalLarge.propTypes = {
  color: PropTypes.string,
  size: PropTypes.number,
  title: PropTypes.string,
  titleId: PropTypes.string
};
export default SvgSportsSnowboardNormalLarge;
